import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { IconNameConvert } from "../iconNameConvert";
import { StoreIconName, storeIcons } from "constants/storeIcons";

interface IProps {
  countryName: string;
  totalStreams: string;
  highestStream: string;
  streams?: { name: string; streamCount: string }[];
}

const CountryItem = ({ countryName, totalStreams, highestStream }: IProps) => {
  const percent = (Number(totalStreams) / Number(highestStream)) * 100;
  const streamsData = [
    { name: "Spotify", streamCount: "3293" },
    { name: "Apple Music", streamCount: "1293" },
    { name: "Deezer", streamCount: "2293" },
    { name: "Amazon", streamCount: "3203" },
    { name: "Audiomack", streamCount: "1250" }
  ];

  return (
    <Container>
      <Typography size="xl" weight="semibold" mb="1">
        {countryName}
      </Typography>
      <StoresContainer>
        {streamsData.map(({ name, streamCount }, i) => {
          let iconName = IconNameConvert(name);
          return (
            <StoreItem key={i}>
              <StoreIcon>{storeIcons[iconName as StoreIconName]}</StoreIcon>
              <Typography color={Colors.grey500} size="xs">
                {Number(streamCount).toLocaleString()}
              </Typography>
            </StoreItem>
          );
        })}
      </StoresContainer>
      <Bar percent={percent} />
      <Typography size="s" mt="0.8" color={Colors.grey400}>
        {Number(totalStreams).toLocaleString()}
      </Typography>
    </Container>
  );
};

export default CountryItem;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const StoresContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.8rem;
`;
const StoreItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;
const StoreIcon = styled.div`
  width: 1rem;
  height: 1rem;
`;

const Bar = styled.div<{ percent: number }>`
  width: ${(props) => `${props.percent}%`};
  height: 4px;
  border-radius: 1rem;
  background-color: ${Colors.yellow400};
`;
